import { render, staticRenderFns } from "./NextIcon.vue?vue&type=template&id=61a5b6b6&scoped=true"
import script from "./NextIcon.vue?vue&type=script&lang=js"
export * from "./NextIcon.vue?vue&type=script&lang=js"
import style0 from "./NextIcon.vue?vue&type=style&index=0&id=61a5b6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5b6b6",
  null
  
)

export default component.exports